import React from "react";
import { GoToTop, LayoutMain, StaticPageLayout } from "../../components/common";

function Terms_mg({
  headline1 = "ALLGEMEINE GESCHÄFTSBEDINGUNGEN BERGFÜHRER",
}) {
  return (
    <LayoutMain>
      <GoToTop />
      <StaticPageLayout title={headline1}>
        <h3>1. Geltungsbereich, Leistungsinhalt</h3>
        <p>
          Der Bergführer erbringt seine Leistungen ausschließlich auf der
          Grundlage der nachfolgenden Allgemeinen Geschäftsbedingungen. Diese
          gelten für alle Rechtsbeziehungen zwischen dem Bergführer und den
          Gästen, selbst wenn nicht ausdrücklich auf sie Bezug genommen wird.
          Der Bergführervertrag umfasst alle Verpflichtung als Bergführer, einen
          Gast auf einer bestimmten Tour zu führen. Im Gegenzug verpflichtet
          sich dieser zur Zahlung des Honorars.
          <br /> Die in den Programmen, Tourenbeschreibungen, oder persönlichen
          Gesprächen genannten Voraussetzungen müssen vom Teilnehmer / von der
          Teilnehmerin erfüllt werden. TeilnehmerInnen unter 18 Jahren haben vor
          Programmbeginn eine schriftliche Einverständniserklärung der
          Erziehungsberechtigten vorzulegen. Für den Zustand und die Wartung
          etwaiger selbst mitgebrachter Ausrüstung sowie den eigenen
          Gesundheitszustand ist jeder Gast eigenverantwortlich. Zur Beurteilung
          der Eignung des einzelnen Gastes für die geplante Tour verpflichtet
          sich dieser zu wahrheitsgemäßen Angaben der dem Bergführer gegenüber.{" "}
          <br /> Aufgrund der gesetzlichen Verpflichtung hat sich der Bergführer
          vor Antritt einer Tour davon zu überzeugen, dass die Gäste ausreichend
          und den Anforderungen entsprechend ausgerüstet sind. Der Bergführer
          behält sich das Recht vor die Führung von Personen abzulehnen, die
          mangelhaft ausgerüstet oder augenscheinlich den Schwierigkeiten der
          geplanten Unternehmung nicht gewachsen sind. In diesem Fall besteht
          kein Anspruch auf Rückerstattung des Honorars. <br /> Trotz bester
          Tourenplanung und Führung kann keine uneingeschränkte Erfolgsgarantie
          für das Erreichen der geplanten Ziele abgeben werden. Entscheidungen
          hinsichtlich der Auswahl zwischen mehreren Routenvarianten, über
          Fortsetzung und Abbruch der Tour, hinsichtlich der Einschaltung von
          Pausen und deren Längen, die Entscheidung hinsichtlich der Mitnahme
          und des Einsatzes von Ausrüstungsgegenständen (vor allem von Seil,
          Steigeisen, Harscheisen, Pickel, usw.) obliegen alleinig dem
          Bergführer. <br /> Für aus Sicherheitsgründen (wie Stein- und
          Eisschlag, Lawinen, Absturz, Wetterumschwünge usw.) oder durch die
          Schuld des Teilnehmers unterbliebene Touren können keine
          Ersatzansprüche geltend gemacht werden. Schäden aus Verlust oder
          Reparaturkosten von Beschädigungen an der Leihausrüstung, die über
          normale Abnützung hinausgehen, sind vom Teilnehmer / der Teilnehmerin
          zu ersetzen. Nach Übergabe der Leihausrüstung an den/die TeilnehmerIn
          ist die Ausrüstung eigenverantwortlich zu prüfen und zu verwenden.
          <br /> Aufgrund der besonderen Verantwortung für die richtige
          Durchführung der Tour verpflichten sich die Gäste mit dem Abschluss
          des Bergführervertrages, sich den Anordnungen des Bergführers, die
          dieser in seiner Funktion als verantwortlicher und sachkundiger Leiter
          der Tour abgibt, zu unterwerfen. Sollten diese von den Gäste ignoriert
          werden, kann der Bergführer für allfällige daraus entstehende Folgen
          nicht zur Verantwortung gezogen werden.
        </p>
        <h3>2. Vertragsabschluss</h3>
        <p>
          Der Bergführervertrag zwischen dem Gast und dem Bergführer kommt
          zustande, wenn Übereinstimmung über die wesentlichen
          Vertragsbestandteile (Ziel/Zweck der Unternehmung, Honorar, Zeitpunkt
          und die Zahl der zu führenden Personen etc.) besteht. Die Buchung kann
          schriftlich oder mündlich erfolgen. Telefonische und mündliche
          Buchungen sind rechtsverbindlich. Bei gleichzeitiger Anmeldung
          mehrerer TeilnehmerInnen haftet der- oder diejenige für die
          Begleichung des Rechnungsbetrages, der/die die Anmeldung vornimmt. Es
          wird Handeln im eigenen Namen vermutet. Im Übrigen haften bei
          Abschluss eines Bergführervertrages für die Leitung einer Bergtour mit
          mehreren Personen alle Gäste für den Honoraranspruch solidarisch zur
          ungeteilten Hand. Dem Bergführer bleibt es vorbehalten, das
          Ausbildungs- und Tourenprogramm wegen unvorhersehbarer Umstände
          jederzeit abzuändern, einzuschränken oder zu erweitern. <br />{" "}
          Aufgrund der Abhängigkeit von Wetterlagen oder anderen nicht
          vorhersehbaren Umständen kann der ursprünglich geplante Tourenverlauf
          nicht immer garantiert werden. Mit der Anmeldung ist eine Anzahlung
          von 50% zu leisten, die Restzahlung hat bis spätestens 7 Tage vor
          Tourantritt auf dem angegebenen Konto abzugs- und spesenfrei
          einzulangen. Es kann auch Barzahlung vor Ort vor Tourantritt
          vereinbart werden.
        </p>
        <h3>3. Wechsel in der Person des Gastes</h3>
        <p>
          Sofern der Gast gehindert ist, die Unternehmung anzutreten, kann er
          das Vertragsverhältnis auf eine andere Person übertragen, sofern diese
          alle Bedingungen für die Teilnahme erfüllt und die Übertragung dem
          Bergführer binnen angemessener Frist vor dem Abreisetermin mitgeteilt
          wird. Der Überträger und der Erwerber haften für das noch unbeglichene
          Entgelt sowie gegebenenfalls für durch die Übertragung entstehende
          Mehrkosten solidarisch zur ungeteilten Hand. Ein Ablehnen der
          Übertragung durch den Bergführer ist aus sachlich gerechtfertigten
          Gründen möglich.
        </p>
        <h3>4. Mindestteilnehmerzahl</h3>
        <p>
          Alle Veranstaltungen können grundsätzlich nur durchgeführt werden,
          wenn die angegebene Mindestteilnehmerzahl erreicht wird. Ist dies
          nicht der Fall, so ist der Bergführer berechtigt, bis 7 Tage vor
          Veranstaltungsbeginn vom Vertrag zurückzutreten. Das bereits
          eingezahlte Honorar wird in voller Höhe rückerstattet. Wenn der Gast
          dennoch auf die Durchführung der Veranstaltung besteht, kann ein neues
          Angebot mit einem neu berechneten Preis unterbreitet werden. Sofern
          der Gast mit dem neu kalkulierten Preis einverstanden ist, kommt ein
          neuer Vertrag zustande. Eine Verpflichtung zur Neudurchführung der
          Veranstaltung seitens des Bergführers besteht jedoch nicht.
        </p>
        <h3>5. Versicherungen</h3>
        <p>
          Der Bergführer verfügt über die gesetzlich vorgeschriebene
          Haftpflichtversicherung. Allfällige private Versicherungen (z. B.
          Unfallversicherung) im Zusammenhang mit den geplanten Touren sind von
          den Gästen selbst abzuschließen. Es wird in diesem Zusammenhang darauf
          hingewiesen, dass bei Hubschrauber- oder Bergrettungseinsätzen sehr
          hohe Kosten anfallen können, die von den zuständigen
          Sozialversicherungsträgern im Regelfall nicht übernommen werden und
          daher vom betroffenen Gast selbst zu bezahlen sind. Es wird daher der
          Abschluss einer Bergekostenversicherung ausdrücklich empfohlen. Es
          besteht grundsätzlich keine Rücktrittsversicherung. Der Gast ist
          selbst für die Einhaltung der allfälliger Pass-, Visa-, Zoll-,
          Devisen- und Gesundheitsvorschriften auf seine Kosten verantwortlich.
        </p>
        <h3>6. Gewährleistung</h3>
        <p>
          Der Gast hat bei nicht oder mangelhaft erbrachter Leistung einen
          Gewährleistungsanspruch. Der Gast erklärt sich damit einverstanden,
          dass ihm anstelle seines Anspruches auf Wandlung oder Preisminderung
          in angemessener Frist eine mangelfreie Leistung erbracht wird, sofern
          dies möglich ist. Zur Durchführung der Verbesserung während der
          laufenden Bergtour besteht jedenfalls eine Anzeigepflicht des Gastes
          an den Bergführer. Ist eine Leistungsstörung in der Sphäre des Gastes
          begründet, wie beispielsweise eine Gesundheitsbeeinträchtigung (z.B.
          eine zu langsame Akklimatisation an die Höhe, mangelnde Kondition,
          udgl.), so kann der Gast daraus keine Ansprüche ableiten.
        </p>
        <h3>7. Schadenersatz</h3>
        <p>
          Im Falle der schuldhaften Verletzung einer aus dem Vertragsverhältnis
          obliegenden Pflicht ist der Bergführer den Gästen gegenüber bei
          Vorliegen aller anderen gesetzlichen Voraussetzungen zum Ersatz der
          daraus entstandenen Schäden im Rahmen der gesetzlich verpflichtet
          abgeschlossenen Haftpflichtversicherung für Personen-, Sach- und
          Vermögensschäden verantwortlich. Der Bergführer haftet nicht im Falle
          einer leichten Fahrlässigkeit. Ebenso ausgeschlossen sind
          Ersatzansprüche aus dem Titel der entgangenen Urlaubsfreude. Ein
          allfälliger Schadenersatz ist der Höhe nach mit der zu diesem
          Zeitpunkt bestehenden Haftpflichtversicherungssumme begrenzt. <br />{" "}
          Von den gesetzlichen Haftungstatbeständen abgesehen nehmen die Gäste
          an den Bergtouren auf eigene Gefahr teil. Ein erhebliches Maß an
          Umsichtigkeit wird bei jedem Gast daher vorausgesetzt. Der
          Bergführer/die Alpinschule kann keine Verantwortung bei
          Unglücksfällen, Schäden oder sonstigen Unregelmäßigkeiten, die sich
          aufgrund der Realisierung alpiner Gefahren (wie z.B. Absturzgefahr,
          Höhenkrankheit, Kälteschäden, Lawinengefahr, Spaltensturz,
          Steinschlag) ergeben, übernehmen. Dies wird vom Gast mit seiner
          Anmeldung ausdrücklich akzeptiert. Alle Veranstaltungen werden nach
          bestem Wissen und Gewissen vorbereitet und geführt. Für Gipfelerfolge
          oder Erfüllung subjektiv vorgestellter Reiseziele kann keine Garantie
          übernommen werden. Es liegt in der Natur der Veranstaltung, dass ein
          bestimmtes Restrisiko und eine Ungewissheit für den Gast bestehen
          bleibt. Eine entsprechende Tourenvorbereitung durch Ausdauersport,
          entsprechendes technisches Training und persönliche Umsichtigkeit
          mindert die Unfallgefahr und wird daher jedem Gast grundsätzlich
          dringend angeraten.
        </p>
        <h3>8. Rücktritt vom Vertrag</h3>
        <p>
          Der Gast hat das Recht, jederzeit schriftlich vom Vertrag
          zurückzutreten. Bei Abmeldung bis spätestens 60 Tage vor
          Programmbeginn entstehen keine Kosten. Bei Stornierung zu einem
          späteren Zeitpunkt entstehen folgende Kosten. <br />
          Stornierung von Individualangeboten:
          <br />
          <ul>
            <li>
              Bis 30 Tage vor Tourantritt 10% vom Honorar, mindestens aber 50
              Euro Bearbeitungsgebühr.
            </li>
            <li>29. bis 19. Tag vor Tourantritt 25% des Honorars.</li>
            <li>18. bis 7. Tag vor Tourantritt 50% des Honorars.</li>
            <li>6. bis 4. Tag vor Tourantritt 75% des Honorars.</li>
            <li>ab dem 3. Tag vor Beginn 100% des Honorars.</li>
          </ul>{" "}
          <br />
          Stornierung von Gruppenangeboten: <br />
          Als Gruppenangebot gelten Angebot ab einer MindestteilnehmerInnenzahl
          von vier Personen. Bei Absage der kompletten Gruppe gelten die
          Stornobedingungen der Individualangebote.
          <br />
          <ul>
            <li>
              Richtet sich der Preis der angebotenen Leistung mit
              Gruppenanschluss nach Anzahl der TeilnehmerInnen, so wird
              unabhängig vom Zeitpunkt der Stornierung die hieraus entstehende
              Differenz als Stornokosten verrechnet.
            </li>
            <li>
              Bei Gruppentouren mit fixem Pauschalpreis wird dieser immer
              vollständig als Stornokosten verrechnet, sofern es weitere
              Anmeldungen gibt.
            </li>
          </ul>{" "}
          <br />
          Zusätzlich sind eventuelle Stornokosten von Hütten, Hotels etc. vom
          Teilnehmer / der Teilnehmerin zu übernehmen. Es wird empfohlen, eine
          Rücktrittsversicherung abzuschließen. Kann der durch den Rücktritt
          freigewordene Platz in Hütten oder Hotels weiterverkauft werden,
          entstehen hierfür keine Kosten. Jedoch sind gewisse Reservierungen
          immer personenbezogen. Terminänderungen gelten wie Stornierung und
          Neuanmeldung. Sollte ein Gast dem vereinbarten Ausgangspunkt der Tour
          fernbleiben oder wenn der Aufbruch zur Tour wegen einer dem Gast
          unterlaufenen Fahrlässigkeit verunmöglicht wird wird das komplette
          Führungshonorar zuzüglich etwaiger Spesen des Bergführers in Rechnung
          gestellt. Bei einem durch höhere Gewalt verursachten Grund können 50%
          des Führungshonorars zuzüglich etwaiger Spesen vom Bergführer
          einbehalten werden. <br />
          Wir empfehlen eine Reise- bzw. Stornoversicherung sowie eine
          Bergeversicher (z. B. via Mitgliedschaft in einem alpinen Verein)
          abzuschließen.
        </p>
        <h3>9. Rücktritt des Bergführers vor Antritt</h3>
        <p>
          Muss der Bergführer aufgrund ungewöhnlicher und unvorhersehbarer
          Ereignisse, auf die er keinerlei Einfluss hatte und deren Folgen trotz
          Anwendung der gebotenen Sorgfalt nicht hätten vermieden werden können,
          vom Vertrag zurücktreten, so hat der Gast die bislang angefallenen
          Spesen zu ersetzen. Zu derartigen Ereignissen zählen etwa staatliche
          Anordnungen, Streiks, Krieg oder kriegsähnliche Zustände,
          Naturkatastrophen, Seuchen, Wetter- und Lawinenverhältnisse etc. Der
          über den Spesenersatz hinausgehende Teil des Führungshonorares wird
          rückerstattet.
        </p>
        <h3>10. Rücktritt seitens des Bergführers nach Antritt der Reise</h3>
        <p>
          Der Bergführer, wird von der Leistungserbringung befreit, wenn ein
          Gast im Rahmen einer Tour durch ungebührliches sowie grob
          unvorsichtiges Verhalten die Durchführung der Unternehmung –
          ungeachtet einer Abmahnung – nachhaltig stört oder andere gefährdet.
          In diesem Fall ist der Gast, sofern ihn ein Verschulden trifft, dem
          Bergführer gegenüber zum Schadenersatz verpflichtet. In einem solchen
          Fall wird das Führungshonorar nicht rückerstattet.
        </p>
        <h3>11. Änderungen des Vertrages</h3>
        <p>
          Die Alpinschule behält sich vor, das mit der Buchung bestätigte
          Honorar aus Gründen, die außerhalb des Einflusses des Bergführers
          liegen, zu erhöhen, sofern der Termin mehr als drei Monate nach dem
          Vertragsabschluss liegt. Derartige Gründe sind etwa die, die Änderung
          allfälliger Beförderungs- und Besteigungskostenkosten oder die für die
          Durchführung der Tour anzuwendenden Wechselkurse. <br />{" "}
          Programmänderungen durch Wetterumschwünge, sonstige alpine Gefahren
          sowie Konditionsschwächen der einzelnen Gäste und sonstiges bleiben
          bei allen Touren vorbehalten. Nach geltendem Berg- und
          Schiführergesetz ist der Bergführer zum Abbruch einer Bergtour
          verpflichtet, wenn unvorhersehbare besondere Umstände eintreten, bei
          denen die körperliche Sicherheit seiner Gäste gefährdet erscheint. Die
          Gäste können aus diesen Umständen somit keine Ersatzansprüche dem
          Bergführer gegenüber geltend machen. Hierbei hat sich die Entscheidung
          nach dem schwächsten Gast zu richten und es teilen die übrigen Gäste
          der Unternehmung dasselbe Schicksal. <br />
          Es gilt der Grundsatz der persönlichen Ausführung des
          Bergführervertrages. Für den Fall einer Verhinderung durch wichtige
          Gründe (beispielsweise Krankheit, Todesfall in der Familie, o. ä.),
          ist der Bergführer zur Übertragung der Führungstätigkeit an einen
          Dritten berechtigt. Der Gast stimmt dieser Übertragungsmöglichkeit
          ausdrücklich zu. In einem solchen Fall ist die Haftung auf ein
          allfälliges Auswahlverschulden begrenzt.
        </p>
        <h3>12. Auskunftserteilung an Dritte</h3>
        <p>
          Auskünfte über die Namen der Gäste sowie die Aufenthaltstorte werden
          an Dritte Personen auch bei dringenden Fällen nicht erteilt, es sei
          denn, die Gäste haben ausdrücklich eine Auskunftserteilung gewünscht.
          Die durch die Übermittlung dringender Nachrichten entstehenden Kosten
          gehen zu Lasten des Reisenden.
        </p>
        <h3>13. Datenschutz und Werbung</h3>
        <p>
          Der Bergführer/die Alpinschule ist berechtigt, personenbezogene Daten
          im Rahmen der Vertragsabwicklung und aus dem Vertrag ergebende Zwecke
          zu verarbeiten und zu speichern. Des Weiteren stimmt der Gast bei
          Buchung ausdrücklich zu, personenbezogene Daten an Kursleiter,
          TeilnehmerInnen und Unterkunft weiter zu geben. Mit der Teilnahme an
          einer Veranstaltung stimmt der Teilnehmer / die Teilnehmerin zu, dass
          Videos und Fotos, die von ihm/ihr während der Unternehmung gemacht
          worden sind, für Werbezwecke des Bergführers verwendet werden dürfen.
        </p>
        <h3>14. Schlussbestimmungen</h3>
        <p>
          Es gilt das österreichische Recht unter Ausschluss der
          Kollisionsnormen. Sollten einzelne Bestimmungen des Vertrags mit dem
          Gast einschließlich dieser Allgemeinen Geschäftsbedingungen ganz oder
          teilweise unwirksam sein oder werden, so wird hierdurch die Gültigkeit
          der übrigen Bestimmungen nicht berührt. Die ganz oder teilweise
          unwirksame Regelung wird durch eine Regelung ersetzt, die dem
          wirtschaftlichen Zweck der unwirksamen möglichst nahe kommt.
        </p>
        <p>
          Gerichtsstand:
          <br />
          Bezirksgericht Zell am See<br />
	  Mozartstraße 2, A-5700 Zell am See
          <br />
          Amtssprache: Deutsch
          <br />
          Stand der AGB: 11.10.2024
        </p>
      </StaticPageLayout>
    </LayoutMain>
  );
}

export default Terms_mg;
